"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertRowHeaderConfigToCellData = void 0;
var convertRowHeaderConfigToCellData = function (_a) {
    var rowHeaderData = _a.rowHeaderData, rowIdx = _a.rowIdx, convertToRichText = _a.convertToRichText;
    return ({
        value: convertToRichText ? convertToRichText(rowHeaderData[rowIdx]) : rowHeaderData[rowIdx], //draftjs data shape
        readOnly: true,
        id: "rowHeaderCell_".concat(rowIdx),
        isRowHeader: true
    });
};
exports.convertRowHeaderConfigToCellData = convertRowHeaderConfigToCellData;
